import axios from 'axios';
import { getApiEndpoint } from './config';
import authService from '../services/auth';

const request = axios.create({
  baseURL: getApiEndpoint(),
  timeout: 10000,
});

// 请求拦截器 - 添加token和刷新检查
request.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // 跳过刷新token请求的检查，避免无限循环
      if (!config.url.includes('/refresh_token') && authService.needsRefresh(token)) {
        const newToken = await authService.refreshToken();
        if (newToken) {
          config.headers.Authorization = `Bearer ${newToken}`;
          return config;
        }
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
request.interceptors.response.use(
  (response) => {
    // 记录成功请求的活动
    authService.recordActivity();
    return response.data;
  },
  (error) => {
    if (error.response) {
      // 处理401未授权
      if (error.response.status === 401) {
        authService.logout();
      }
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
);

export default request;
